/** Perfil do fornecedor enviado na solicitação de cadastro (guia → admin Parceiros). */

export interface CertificadoParceiroRow {
  descricao: string;
  anexo: string;
  nomeArquivo?: string;
  /** Data de conclusão (YYYY-MM-DD). */
  dataConclusao?: string;
  /** @deprecated — usar dataConclusao */
  dataValidade?: string;
  tipoDocumento?: 'primeiros_socorros' | 'guia_condutor' | 'outros';
  outrosDetalhe?: string;
}

export interface PerfilSolicitacaoFornecedor {
  cpf: string;
  telefone: string;
  chavePix: string;
  baseCidadeId: string;
  imagemPerfil?: string;
  /** Fotos do trabalho — guia (até 4). */
  fotosTrabalhoGuia?: string[];
  /** Fotos do trabalho — terapeuta (até 4). */
  fotosTrabalhoTerapeuta?: string[];
  /** Lista alinhada ao admin (Parceiros → Certificados). */
  certificados?: CertificadoParceiroRow[];
  /** Resumo profissional (GUIA / TERAPEUTA), mesmo campo do admin. */
  resumoPerfil?: string;
  /** ID da agência ou vazio — “Sem associação”. */
  agenciaId?: string;
  /** Certificado de conclusão do curso de guia (obrigatório para guia/terapeuta no app). */
  certificadoGuiaAnexo?: string;
  certificadoGuiaDataConclusao?: string;
  /** RG, CNH ou CPF (documento de identidade) — obrigatório para todo fornecedor. */
  documentoIdentidadeFornecedor?: string;
  /** Documento de identificação — opcional (obrigatório no app se houver agenciaId). */
  documentoOpcionalAnexo?: string;
  /** Certificado de primeiros socorros — opcional. */
  certificadoAnexo?: string;
  certificadoDataConclusao?: string;
}

function descricaoConclusaoGuia(d: string): boolean {
  const x = (d || '').toLowerCase();
  if (x.includes('conclusão') || x.includes('conclusao')) return true;
  if (x.includes('guia') && x.includes('condutor')) return true;
  if (x.includes('certificado de guia ou condutor')) return true;
  return false;
}

/** Monta a lista de certificados enviada ao admin (prioriza `certificados[]`; completa com campos legados). */
export function mergeCertificadosParaAdmin(perfil: PerfilSolicitacaoFornecedor): CertificadoParceiroRow[] {
  const fromList = (perfil.certificados ?? [])
    .filter((c) => (c.anexo || '').trim() && (c.descricao || '').trim())
    .map((c) => {
      const row = c as CertificadoParceiroRow;
      const dataConclusao =
        (row.dataConclusao || row.dataValidade || '').trim().slice(0, 10) || undefined;
      const nomeArquivo = (row.nomeArquivo || '').trim() || undefined;
      const tipoDocumento = row.tipoDocumento;
      const outrosDetalhe = (row.outrosDetalhe || '').trim() || undefined;
      return {
        descricao: c.descricao.trim(),
        anexo: c.anexo.trim(),
        ...(nomeArquivo ? { nomeArquivo } : {}),
        ...(dataConclusao ? { dataConclusao } : {}),
        ...(tipoDocumento ? { tipoDocumento } : {}),
        ...(outrosDetalhe ? { outrosDetalhe } : {}),
      };
    });

  const hasConclusaoGuia = fromList.some((c) => descricaoConclusaoGuia(c.descricao));
  const anexoGuiaLegado = (perfil.certificadoGuiaAnexo ?? '').trim();
  if (!hasConclusaoGuia && anexoGuiaLegado) {
    fromList.unshift({
      descricao: 'Certificado de Guia ou Condutor',
      anexo: anexoGuiaLegado,
      dataConclusao: (perfil.certificadoGuiaDataConclusao ?? '').trim().slice(0, 10) || undefined,
      tipoDocumento: 'guia_condutor',
    });
  }

  const hasPs = fromList.some((c) => (c.descricao || '').toLowerCase().includes('primeiros'));
  const anexoPs = (perfil.certificadoAnexo ?? '').trim();
  if (!hasPs && anexoPs) {
    fromList.push({
      descricao: 'Primeiros socorros',
      anexo: anexoPs,
      dataConclusao: (perfil.certificadoDataConclusao ?? '').trim().slice(0, 10) || undefined,
      tipoDocumento: 'primeiros_socorros',
    });
  }

  return fromList;
}
